@if (isResolverLoading) {
  <div class="page__fullscreen-spinner-container">
    <mat-spinner [diameter]="100"></mat-spinner>
    <h3>Loading {{ pageTitleText }}...</h3>
  </div>
} @else {
  <router-outlet></router-outlet>
}